// Messages browsers use when a code-split chunk (a lazily loaded page) fails to
// download — e.g. a network blip, or old chunk files removed by a new deploy
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

// A failed chunk usually means a new deploy: reload once to pick up the new
// files, but never loop — a second failure within this window shows the message
const RELOAD_KEY = 'chunk-error-reload-at';
const RELOAD_WINDOW_MS = 10_000;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);
}

export function reloadedRecently(): boolean {
  try {
    const at = Number(sessionStorage.getItem(RELOAD_KEY));
    return Number.isFinite(at) && Date.now() - at < RELOAD_WINDOW_MS;
  } catch {
    return true; // storage unavailable: don't risk a reload loop
  }
}

export function markReload() {
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // ignore — reloadedRecently() treats missing storage as "already reloaded"
  }
}
